import React from 'react';
import WhatsAppIcon from './WhatsAppIcon';

const MeioEnvioLabel = ({ meio, iconSize = 18, whatsappColor }) => {
  const wrapStyle = { display: 'inline-flex', alignItems: 'center', gap: '0.35rem', verticalAlign: 'middle' };

  if (meio === 'whatsapp') {
    return (
      <span style={wrapStyle}>
        <WhatsAppIcon size={iconSize} color={whatsappColor || '#25D366'} />
        <span>WhatsApp</span>
      </span>
    );
  }
  if (meio === 'sms') {
    return (
      <span style={wrapStyle}>
        <span aria-hidden>📱</span>
        <span>SMS</span>
      </span>
    );
  }
  if (meio === 'email') {
    return (
      <span style={wrapStyle}>
        <span aria-hidden>📧</span>
        <span>E-mail</span>
      </span>
    );
  }
  return <span>{meio}</span>;
};

export const MeiosEnvioList = ({ meios, iconSize = 18, whatsappColor }) => {
  if (!meios?.length) return null;
  return meios.map((meio, index) => (
    <React.Fragment key={meio}>
      {index > 0 && ' • '}
      <MeioEnvioLabel meio={meio} iconSize={iconSize} whatsappColor={whatsappColor} />
    </React.Fragment>
  ));
};

export default MeioEnvioLabel;
